import AuthService from '../services/auth.service';
const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: { loggedIn: false }, user: null };
export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit }, user) {
            return AuthService.login(user).then(
                user => {
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit('logout');
        },
        refreshToken({ commit }, accessToken) {
            commit('refreshToken', accessToken);
        },
        register({ commit }, user) {
            return AuthService.register(user).then(
                response => {
                    commit('registerAdminSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        registerAdmin({ commit }, user) {
            return AuthService.registerAdmin(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        registerUser({ commit }, user) {
            return AuthService.registerLoginUser(user).then(
                response => {
                    commit('createUserSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('createUserFailure');
                    return Promise.reject(error);
                }
            );
        },
        forgotPassword({ commit }, user) {
            return AuthService.forgotPassword(user).then(
                response => {
                    commit('forgotPasswordSuccess');
                    return Promise.resolve(response);
                },
                error => {
                    commit('forgotPasswordFailure');
                    return Promise.reject(error);
                }
            );
        },
        confirmForgotPassword({ commit }, params){
            return AuthService.confirmForgotPassword(params).then(
                response => {
                    commit('confirmForgotPasswordSuccess');
                    return Promise.resolve(response);
                },
                error => {
                    commit('confirmForgotPasswordFailure');
                    return Promise.reject(error);
                }
            );
        },
        update({ commit }, user) {
            return AuthService.updateUser(user).then(
                response => {
                    commit('updateSuccess', user);
                    return Promise.resolve(response.data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateSuccess(state, user) {
            state.user.name = user.firstName;
            state.user.lastName = user.lastName;
            localStorage.setItem("user", JSON.stringify(state.user));
        },
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        refreshToken(state, accessToken) {
            state.status.loggedIn = true;
            state.user = { ...state.user, accessToken: accessToken };
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        },
        forgotPasswordSuccess(state) {
            state.status.loggedIn = false;
        },
        forgotPasswordFailure(state) {
            state.status.loggedIn = false;
        },
        confirmForgotPasswordSuccess(state) {
            state.status.loggedIn = false;
        },
        confirmForgotPasswordFailure(state) {
            state.status.loggedIn = false;
        },
        createUserSuccess(){

        },
        createUserFailure(){

        }
    }
};
